
export default function formCadastroUpdateDTO({
        nome, 
        nascimento, 
        email, 
        login, 
        celular,
        rua, 
        numero, 
        bairro, 
        complemento, 
        cep, 
        cidade,
        uf, 
        acesso, 
        ativo
    }){ 
        return{
        nome, 
        nascimento, 
        email, 
        login, 
        celular,
        rua, 
        numero, 
        bairro, 
        complemento, 
        cep, 
        cidade, 
        uf,
        acesso,
        ativo
    }
}